import React from 'react';
import { Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import CommonSymptoms from './CommonSymptoms';
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import VideoVisitAvailability from './VideoVisitAvailability';
import * as Tools from "../../helpers/Tools";
import moment from 'moment-timezone';
import { logUI } from "../../api/andyliticsApi";
import MiniSpinner from "../common/MiniSpinner";
import * as d from "../../reducers/domainReducer";

const SLOTS_NEEDED_ON_CALL = 3;
const SLOTS_NEEDED_NEW_DOCTOR = 2;
const SLOTS_NEEDED_YOUR_DOCTOR = 2;
const timeZones = {
    CST: 'Central Standard Time',
    CDT: 'Central Daylight Time'
};

class VideoVisitOptions extends React.Component {
    constructor(props) {
        super(props);
        const onCallDoctorSchedule = props && (props.isActiveFeature_SDCVideoVisit || props.hasAuthorizedFeatureSameDayVideo);
        this.state = {
            openModal: false,
            activeTab: props && !props.videoVisitTypeForYourDoctorAvailability & onCallDoctorSchedule ? "3" : props.providerList && props.providerList.length > 0 ? "1" : "2",
            selectedUser: this.props && this.props.location && this.props.location.state && this.props.location.state.selectedUser,
            newDoctorAvailableTimes: []
        };
        this.availableTimesSDC = [];
        // this.newDoctorAvailableTimes = [];
        this.yourDoctorAvailableTimes = [];
        this.newDoctorSearchResultCallback = this.newDoctorSearchResultCallback.bind(this);
    }

    componentDidMount() {
        const date = Tools.getFormattedDate(new Date());
        const clientUTCOffset = this.props.showTimeZoneMessage ? moment.tz("America/Chicago").utcOffset() : moment().utcOffset();//We show central time
        const { getVideoVisitTimeSlots, showVideoVisitAvailability, isActiveFeature_SDCVideoVisit, providerList, getProvidersListByVisitType,
            getEarliestDirectVideoVisitScheduleForProviders, getProviderWithEarliestSchedule, resetNewDoctorResults } = this.props;
        const isSameDayEnabled = isActiveFeature_SDCVideoVisit;

        resetNewDoctorResults();
        //this.newDoctorAvailableTimes = [];
        if (this.state.newDoctorAvailableTimes && this.state.newDoctorAvailableTimes.length > 0) {
            this.setState({
                newDoctorAvailableTimes: []
            });
        }
        this.availableTimesSDC = [];
        if (showVideoVisitAvailability && isSameDayEnabled) {
            getVideoVisitTimeSlots(clientUTCOffset, date);
            //if (enableV3VideoVisitApi) { getEarliestDirectVideoVisitScheduleForProviders(epicIdNDepartId); }
            //else { getVideoVisitTimeSlots(clientUTCOffset, date);}
        }

        const { getGeoLocation, curPosLatitude, curPosLongitude, waitingOnGeolocation } = this.props;
        if (!curPosLatitude && !curPosLongitude && !waitingOnGeolocation) {
            logUI("MBHWeb.UI.VideoVisitOptions.GetGeoLocationBasedOnIPAddress", new Date(), Tools.getURLPath());
            getGeoLocation(false); //Getting ip address based location 
            this.ipSearched = true;
        }

        logUI("MBHWeb.UI.VideoVisitOptions.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        const { userName, getUserAddress, curPosLatitude, curPosLongitude, getGeoLocation, geolocationError, waitingOnGeoAddress, waitingOnGeolocation,
            fetchingUserAddress, searchProviders, providerListPending, getProvidersListByVisitType,
            getProviderWithEarliestSchedule, videoVisitTypeForYourDoctorAvailability, providerNpiListStr, token, currentuser, serverData, isSwitchingProxy } = this.props;

        if (prevProps && prevProps.providerNpiListStr && providerNpiListStr && prevProps.providerNpiListStr !== providerNpiListStr) {
            this.fetchYourDoctors = false;
            //Reseting due to filter out Direct Scheduling doctors based on npi and display the first non-Direct Scheduling doctor in the Phynd api results.
            if (this.state.newDoctorAvailableTimes && this.state.newDoctorAvailableTimes.length > 0) {
                this.setState({
                    newDoctorAvailableTimes: []
                });
            }
        }

        if (!providerListPending && providerNpiListStr && (!this.fetchYourDoctors && !isSwitchingProxy)
            && videoVisitTypeForYourDoctorAvailability) {
            this.yourDoctorAvailableTimes = [];

            if (serverData && serverData.enableV3VideoVisitApi) {
                let searchModel = {
                    loginId: this.props.userName,
                    proxyPatientId: currentuser.externalId,
                    proxyPatientIdType: "External",
                    visitTypeId: videoVisitTypeForYourDoctorAvailability
                };

                logUI("MBHWeb.UI.VideoVisitOptions.GetProvidersListByVisitType", new Date(), Tools.getURLPath());
                getProvidersListByVisitType(searchModel, token);
            } else {
                let searchModel = { Ids: providerNpiListStr, idType: "Npi", visitTypeId: videoVisitTypeForYourDoctorAvailability, numberOfDays: "30" };
                logUI("MBHWeb.UI.VideoVisitOptions.GetProviderWithEarliestSchedule", new Date(), Tools.getURLPath());
                getProviderWithEarliestSchedule(searchModel);
            }

            this.fetchYourDoctors = true;
        }

        if ((!this.alreadySearched && !this.ipSearched) && !curPosLatitude && !curPosLongitude && !waitingOnGeolocation) {
            logUI("MBHWeb.UI.VideoVisitOptions.GetGeoLocationBasedOnIPAddress", new Date(), Tools.getURLPath());
            getGeoLocation(false); //Getting ip address based location 
            this.ipSearched = true;
        }
        else if ((!this.alreadySearched && !this.addressSearched) && geolocationError && !curPosLatitude && !curPosLongitude && !waitingOnGeoAddress && !fetchingUserAddress && !waitingOnGeolocation) {
            if (userName) {
                logUI("MBHWeb.UI.VideoVisitOptions.GetUserAddress", new Date(), Tools.getURLPath());
                getUserAddress(userName); //Getting User Address
                this.addressSearched = true;
            }
        }
        else if (!this.alreadySearched && !fetchingUserAddress && !waitingOnGeolocation && !waitingOnGeoAddress) {//if we are not waiting on any above apis, finally call the search api.
            //console.log("search all", userAddress[0].City);
            const searchModel = {
                keyword: "Primary Care Provider",
                vectorName: "pcp",
                specialty: "Family Medicine",
                pageNumber: 1,
                perPage: 1,
                sortBy: "NextAvailableAppointment",
                overrideRules: false,
                distance: 20,
                visitType: "Video Visit",
                openScheduling: true
            };
            const location = this.getLocation();
            if (location)
                searchModel.location = location;
            logUI("MBHWeb.UI.VideoVisitOptions.FindNewDoctor.SearchProviders", new Date(), Tools.getURLPath(), searchModel);
            searchProviders(searchModel, this.newDoctorSearchResultCallback);//call this to get new doctor available times.
            this.alreadySearched = true;
        }
    }

    newDoctorSearchResultCallback() {
        const { newDoctorProviders } = this.props;
        if (newDoctorProviders && newDoctorProviders.length > 0 && this.state.newDoctorAvailableTimes.length === 0) {
            this.getNewDoctorTimeSlotDetails(newDoctorProviders);
        }
    }

    getLocation = () => {
        const { curPosLatitude, curPosLongitude, geolocationError, geoAddressError, city, state } = this.props;
        let location = "";
        //assuming it falls into one of the three usecase scenario as per geoapi call made on intial loads.
        if (geolocationError && geoAddressError) {
            location = "";
            //console.log("no location on error");
        }
        else { //if location access allowed           
            if (curPosLatitude && curPosLongitude)
                location = curPosLatitude + ',' + curPosLongitude;
            else if (city && state)
                location = city + ',' + state;
            //console.log("some location or none", location);
        }

        return location;
    }

    linkMyInsurance = () => {
        logUI("MBHWeb.UI.VideoVisitOptions.LinkMyInsurance.Clicked", new Date(), Tools.getURLPath());
        this.props.history.push({
            pathname: '/linkedaccounts',
            searchParams: "openInsurance=true"
        });
    }

    SeeAllSlotsInOnCallDoctor = () => {
        logUI("MBHWeb.UI.VideoVisitOptions.SeeAllSlotsInOnCallDoctor.Clicked", new Date(), Tools.getURLPath());
        this.props.history.push('/schedulevideovisit');
    }

    findNewDoctor = () => {
        const { newDoctorProvidersSuccess, newDoctorProviders } = this.props;
        logUI("MBHWeb.UI.VideoVisitOptions.FindNewDoctor.Clicked", new Date(), Tools.getURLPath());
        this.props.history.push({
            pathname: "/inperson",
            state: {
                fromVideoVisitPage: true,
                newDoctorSearchQuery: newDoctorProvidersSuccess && (!newDoctorProviders || (newDoctorProviders && newDoctorProviders.length === 0)) ? "keyword=Primary Care Provider&vectorName=pcp&sortBy=NextAvailableAppointment&specialty=Family Medicine&distance=25" : "keyword=Primary Care Provider&vectorName=pcp&sortBy=NextAvailableAppointment&specialty=Family Medicine"
            }
        });
    }

    seeAllYourDoctors = () => {
        logUI("MBHWeb.UI.VideoVisitOptions.SeeAllYourDoctors.Clicked", new Date(), Tools.getURLPath());
        const { providerList, history, serverData } = this.props;
        if (providerList && providerList.length > 0) {
            history.push({
                    pathname: "/schedule/videovisit/DirectSchedule",
                    state: { selectedUser: this.state.selectedUser, noSelectPatient: true, isFromVideoVisitOptions: true }
            });
        } else {
            history.push("/findcare");
        }
    }

    commonSymptomsInfo = () => {
        const { symptoms, getVideoVisitConditions } = this.props;
        this.setState({
            openModal: true
        });
        if (symptoms === null) {
            getVideoVisitConditions();
        }
    }

    toggleModal = () => {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    toggleTabs = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    iterateSlots(partOfDay, items, formatNeeded = false) {
        const { showTimeZoneMessage } = this.props;
        if (!partOfDay || partOfDay.length === 0) return items;
        const timings = partOfDay.map((item, index) => { return showTimeZoneMessage ? moment(item.dateTimeInDallas).format("h:mm A") : moment.utc(item.dateTimeInUtc).local().format("h:mm A"); });
        if (!timings || timings.length === 0) return items;

        for (let i = 0; i < timings.length; i++) {
            if (items.length < SLOTS_NEEDED_ON_CALL) {
                let centralDay = Tools.isCentralTimeZone() && !formatNeeded ? "TODAY" : moment(partOfDay[i].dateTimeInDallas).format("ddd. MMM DD");
                let utcDay = !formatNeeded ? "TODAY" : moment.utc(partOfDay[i].dateTimeInUtc).local().format("ddd. MMM DD");
                items.push({
                    selectedDay: showTimeZoneMessage ? centralDay : utcDay,
                    timeSlot: partOfDay[i],
                    time: timings[i],
                    day: showTimeZoneMessage ? centralDay : utcDay,
                    redirectTo: "/schedulevideovisit"
                });
            }
            else
                break;
        }
        return items;
    }

    getYourDoctorTimeSlotDetails(provider) {
        const openSchedule = provider;
        const { showTimeZoneMessage } = this.props;
        let items = [];
        let npiId = "";
        for (let ids of providerSlots.provider.iDs) {
            for (let id in ids) {
                if (ids.type === "ProviderNPI") {
                    npiId = ids.id;
                }
                    
            }
        }
        if (openSchedule && openSchedule.slots) {
            for (let i = 0; i < openSchedule.slots.length; i++) {
                const slot = openSchedule.slots[i];
                if (slot) {
                    let datetimearray = slot.date.split('T');
                    const date = datetimearray[0]; //"2020-09-30";
                    const time = datetimearray[1]; //"07:00:00";
                    if (items.length < SLOTS_NEEDED_YOUR_DOCTOR) {
                        let centralDay = Tools.isCentralTimeZone() && slot.dayString.includes("Today") ? "TODAY" : moment(Tools.convertDateToCentralTz(slot.date)).format("ddd. MMM DD");
                        let utcDay = slot.dayString.includes("Today") ? "TODAY" : moment.utc(slot.date).local().format("ddd. MMM DD");
                        items.push({
                            selectedDay: slot.dayString,
                            time: slot.timeString,
                            day: showTimeZoneMessage ? centralDay : utcDay,
                            visitTypeId: slot.visitTypeId,
                            departmentId: slot.departmentId,
                            dateTimeString: slot.date,
                            displayName: provider.displayName,
                           // npi: provider.npi, //this need not be repeated
                            npi: npiId ? npiId : null,
                            photo: provider.photoUrl,//this need not be repeated
                            specialty: provider.specialty, //this need not be repeated    
                            redirectTo: `/schedule/${provider.npi}/${slot.visitTypeId}/${slot.departmentId}/${date}/${time}`,
                            moreUrl: `/schedule/${provider.npi}/DirectSchedule`
                        });
                    }
                    else {
                        break;
                    }
                }

                if (items.length > SLOTS_NEEDED_YOUR_DOCTOR) {
                    break;
                }
            }
        }
        this.yourDoctorAvailableTimes = items;
    }

    getYourDoctorTimeSlotDetailsV3(providerSlots) {
        const { showTimeZoneMessage } = this.props;
        let items = [];
        let npiId = "";
        if (providerSlots && providerSlots.provider && providerSlots.provider.iDs) {
            for (let ids of providerSlots.provider.iDs) {
                for (let id in ids) {
                    if (ids.type === "ProviderNPI") {
                        npiId = ids.id;
                    }
                        
                }
            }
        }
        const openSchedule = providerSlots && providerSlots.scheduleDays && providerSlots.scheduleDays.length > 0 ?
            providerSlots.scheduleDays[0] : null;
        let isToday = false;
        if (openSchedule && openSchedule.date) {
            //We are not getting date with time format, so we have timezone issue. For temp fix adding T00:00:00
            const slotDate = new Date(`${openSchedule.date}T00:00:00`);
            const today = new Date();
            if (today.getDate() === slotDate.getDate() && today.getMonth() === slotDate.getMonth() && today.getFullYear() === slotDate.getFullYear()) {
                isToday = true;
            }
        }
        if (providerSlots && providerSlots.providerInfo && openSchedule && openSchedule.slots) {
            for (let i = 0; i < openSchedule.slots.length; i++) {
                const slot = openSchedule.slots[i];
                const displayName = providerSlots.providerInfo.displayName ? providerSlots.providerInfo.displayName : null;
                //const npi = providerSlots.providerInfo.npi ? providerSlots.providerInfo.npi : null;
                const npi = npiId ? npiId : null;
                const photo = providerSlots.providerInfo.photoUrl ? providerSlots.providerInfo.photoUrl : null;
                const specialty = providerSlots.providerInfo.specialty ? providerSlots.providerInfo.specialty : null;
                const visitTypeId = openSchedule.visitType && openSchedule.visitType.id ? openSchedule.visitType.id : null;
                const departmentId = openSchedule.department && openSchedule.department.id ? openSchedule.department.id : null;
                if (slot && openSchedule.date) {
                    //let datetimearray = openSchedule.date.split('T');
                    const date = openSchedule.date; //"2020-09-30";
                    const time = slot.time; //"07:00:00";
                    if (items.length < SLOTS_NEEDED_YOUR_DOCTOR) {
                        let centralDay = Tools.isCentralTimeZone() && isToday ? "TODAY" : moment(Tools.convertDateToCentralTz(date)).format("ddd. MMM DD");
                        let utcDay = isToday ? "TODAY" : moment.utc(date).local().format("ddd. MMM DD");
                        const displayTime = time ? moment(time, ["HH.mm"]).format("hh:mm a") : null;
                        items.push({
                            selectedDay: centralDay,
                            time: displayTime,
                            day: showTimeZoneMessage ? centralDay : utcDay,
                            visitTypeId,
                            departmentId,
                            dateTimeString: date,
                            displayName,
                            npi, //this need not be repeated
                            photo,//this need not be repeated
                            specialty, //this need not be repeated    
                            redirectTo: `/schedule/${npi}/${visitTypeId}/${departmentId}/${date}/${time}`,
                            moreUrl: `/schedule/${npi}/DirectSchedule`
                        });
                    }
                    else {
                        break;
                    }
                }

                if (items.length > SLOTS_NEEDED_YOUR_DOCTOR) {
                    break;
                }
            }
        }
        this.yourDoctorAvailableTimes = items;
    }

    getNewDoctorTimeSlotDetails(providers) {
        const { providerNpiList } = this.props;
        const { showTimeZoneMessage } = this.props;
        let provider = null;
        let items = [];
        for (let prov = 0; prov < providers.length; prov++) {
            //Filter out Direct Scheduling doctors based on npi and display the first non-Direct Scheduling doctor in the Phynd api results.
            if (providerNpiList.length === 0 || (providers[prov].provider && providers[prov].provider.npi &&
                providerNpiList.length > 0 && providerNpiList.indexOf(providers[prov].provider.npi) === -1)) {
                provider = providers[prov].provider;
                break;
            }
        }

        const openSchedule = provider && provider.locations && provider.locations.length > 0 && provider.locations[0] ?
            provider.locations[0].openSchedules : null;

        if (openSchedule && openSchedule.dateAndTimes) {
            for (let tslots = 0; tslots < openSchedule.dateAndTimes.length; tslots++) {
                const times = openSchedule.dateAndTimes[tslots].times;
                if (times) {
                    for (let i = 0; i < times.length; i++) {
                        let datetimearray = times[i].time.split('T');
                        const date = datetimearray[0]; //"2020-09-30";
                        const time = datetimearray[1]; //"07:00:00";
                        if (items.length < SLOTS_NEEDED_NEW_DOCTOR) {
                            let centralDay = Tools.isCentralTimeZone() && openSchedule.dateAndTimes[tslots].dayString.includes("Today") ? "TODAY" : moment(Tools.convertDateToCentralTz(times[i].time)).format("ddd. MMM DD");
                            let utcDay = openSchedule.dateAndTimes[tslots].dayString.includes("Today") ? "TODAY" : moment.utc(times[i].time).local().format("ddd. MMM DD");
                            items.push({
                                selectedDay: openSchedule.dateAndTimes[tslots].dayString,
                                time: times[i].timeString,
                                day: showTimeZoneMessage ? centralDay : utcDay,
                                visitTypeId: times[i].visitTypeId,
                                departmentId: times[i].departmentId,
                                dateTimeString: times[i].time,
                                displayName: provider.displayName,
                                npi: provider.npi, //this need not be repeated
                                photo: provider.photo,//this need not be repeated
                                specialties: provider.specialties, //this need not be repeated    
                                redirectTo: `/schedule/${provider.npi}/${times[i].visitTypeId}/${times[i].departmentId}/${date}/${time}`,
                                moreUrl: `/schedule/${provider.npi}/OpenSchedule/${times[i].visitTypeId}/${times[i].departmentId}`
                            });
                        }
                        else {
                            break;
                        }
                    }
                }

                if (items.length > SLOTS_NEEDED_NEW_DOCTOR) {
                    break;
                }
            }
        }

        // this.newDoctorAvailableTimes = items;

        this.setState({
            newDoctorAvailableTimes: items
        });
    }

    //Looping through each item untill we fill SDC appts.
    getVideoVisitAvailabilityData() {
        const { timeslots } = this.props.videoVisitTimeSlots;
        let items = [];
        if (timeslots) {
            const [today = [], tomorrow = []] = timeslots;
            items = this.iterateSlots(today && today.morning, items);
            if (items.length < SLOTS_NEEDED_ON_CALL)
                items = this.iterateSlots(today && today.afternoon, items);
            if (items.length < SLOTS_NEEDED_ON_CALL)
                items = this.iterateSlots(today && today.evening, items);

            if (items.length < SLOTS_NEEDED_ON_CALL)
                items = this.iterateSlots(tomorrow && tomorrow.morning, items, true);
            if (items.length < SLOTS_NEEDED_ON_CALL)
                items = this.iterateSlots(tomorrow && tomorrow.afternoon, items, true);
            if (items.length < SLOTS_NEEDED_ON_CALL)
                items = this.iterateSlots(tomorrow && tomorrow.evening, items, true);
            this.availableTimesSDC = items;
        }
    }

    //get next day with particular format
    //getNextDayFormat(selectedDay, daySlot) {
    //    const { timeslots } = this.props.videoVisitTimeSlots;
    //    return timeslots && daySlot && moment.utc(timeslots[selectedDay][daySlot][0].dateTimeInUtc).local().format("ddd. MMM YY");
    //}

    //full details of selected time slotsto send to next steps.
    //getDisplayedTimeSlots(selectedDay, daySlot) {
    //    const { timeslots } = this.props.videoVisitTimeSlots;
    //    return timeslots && daySlot && timeslots[selectedDay][daySlot].map((item, index) => { return item; });
    //}

    //get times to display in particular format.
    //getTimes(selectedDay, daySlot) {
    //    const { timeslots } = this.props.videoVisitTimeSlots;
    //    return timeslots && daySlot && timeslots[selectedDay][daySlot].map((item, index) => { return moment.utc(item.dateTimeInUtc).local().format("h:mm A"); });
    //}

    //specific slot for selected day.
    //getSlot(selectedDay) {
    //    const { timeslots } = this.props.videoVisitTimeSlots;
    //    //return timeslots && (timeslots[selectedDay].morning.length > 0 ? "morning"
    //      //  : timeslots[selectedDay].afternoon.length > 0 ? "afternoon"
    //    //    : timeslots[selectedDay].evening.length > 0 ? "evening" : null);
    //    return timeslots && timeslots[selectedDay] ? [timeslots[selectedDay].morning, timeslots[selectedDay].afternoon, timeslots[selectedDay].evening, timeslots[selectedDay].dateLabel] : [];
    //}


    render() {
        const { hasSwhp, hasAAL, isProxyUser, symptoms, isSymptomsWaiting, providerList, serverData, location,
            videoVisitTimeSlots, showVideoVisitAvailability, newDoctorProviders, newDoctorProvidersWaiting, newDoctorProvidersError, newDoctorProvidersSuccess,
            earliestScheduleSuccess, earliestScheduleWaiting, earliestScheduleError, earliestScheduleProvider, waitingOnGeoAddress, waitingOnGeolocation, fetchingUserAddress, videoVisitTypeForYourDoctorAvailability,
            SDCCostLabel, isActiveFeature_SDCVideoVisit, hasAuthorizedFeatureSameDayVideo, isActiveFeature_AmbulatoryVideoVisit, AmbulatoryCostLabel, outOfStateOptionsForSdc, showTimeZoneMessage, currentuser, showSDC24By7TextInOnCallProvider } = this.props;
        
        const showYourDoctors = isActiveFeature_AmbulatoryVideoVisit && providerList && providerList.length > 0;
        const { timeslots, isWaiting, isSuccess, isError } = videoVisitTimeSlots;
        if (showVideoVisitAvailability && this.availableTimesSDC.length === 0)
            this.getVideoVisitAvailabilityData();//call this to get available time slots for SDC.

        if (!earliestScheduleWaiting && earliestScheduleProvider && this.yourDoctorAvailableTimes.length === 0) {
            if (serverData && serverData.enableV3VideoVisitApi) {
                this.getYourDoctorTimeSlotDetailsV3(earliestScheduleProvider);
            } else {
                this.getYourDoctorTimeSlotDetails(earliestScheduleProvider);
            }
        }

        const restrictLocalAndOncallDoctorTile = serverData && serverData.restrictVideoVisitForUnderAgeProxies && currentuser && typeof currentuser.ageYears !== 'undefined' && currentuser.ageYears !== '' && currentuser.ageYears !== null
                                                                                                        && currentuser.ageYears <= 2;

        const isFromCovid19ScreenerSurvey = location && location.state && location.state.isFromCovid19ScreenerSurvey ? true : false;

        const covid19TestLocation = serverData && serverData.covid19TestLocation ? serverData.covid19TestLocation : null;

        const showNotEligibleMsg = !restrictLocalAndOncallDoctorTile && !isActiveFeature_AmbulatoryVideoVisit && !isActiveFeature_SDCVideoVisit;

        const showMarkupForNotEligible = (<div id="videovisit-noteligible" className="row">
            <div className="col-12">
                <label id="videovisitNotEligibleMessage">
                    You're not eligible to complete a Video Visit. For assistance, please call the MyBSWHealth technical help desk {this.props.technicalHelpDeskHours} at <a href={"tel:" + this.props.technicalHelpDeskNumber} className="phone-link">{this.props.technicalHelpDeskNumber}</a>.<br /><br />
                </label>
                <div className="video-visit-ineligible-btn-links">
                    <Link className="btn-link-style" onClick={(e) => { logUI("MBHWeb.UI.VideoVisitOptions.InEligible.FindDoctor.Clicked", new Date(), Tools.getURLPath()); }} to={{ pathname: "/findcare" }}>FIND A DOCTOR</Link>
                    {isFromCovid19ScreenerSurvey && <Link className="btn-link-style" onClick={(e) => { logUI("MBHWeb.UI.VideoVisitOptions.InEligible.Covid19TestingLocation.Clicked", new Date(), Tools.getURLPath()); }} to={{ pathname: covid19TestLocation }} target="_blank">FIND A COVID-19 TESTING LOCATION</Link>}
                </div>
            </div>
        </div>);

        const restrictLocalAndOncallDoctorMarkup = () => {
            return (
                <div className="col-12 video-visit-message-container">
                        <div className="align-items-start message-heading">
                             <div className="svg-combined" /><p>BSWH does not offer video visits for patients in this age group  who do not currently have a relationship with primary care provider. Please schedule an in-person visit. 
                                <Link className="icontextlink mobile-wrapped-link link-text" to={{ pathname: "/dashboard" }} > Go back to the dashboard for in-person visit options.</Link></p>
                             </div>
                </div>
            )
        }

        const showOnCallDoctor = !restrictLocalAndOncallDoctorTile && isActiveFeature_SDCVideoVisit && !isFromCovid19ScreenerSurvey; // headerProxyUser && headerProxyUser.sameDayVideoInfo && isActiveFeature_SDCVideoVisit && (headerProxyUser.sameDayVideoInfo.IsSameDayVideoEligible || headerProxyUser.sameDayVideoInfo.HasSameDayVideoAuthorizedFeature);
        const disableOnCallGetStarted = !isActiveFeature_SDCVideoVisit && hasAuthorizedFeatureSameDayVideo;
        const hasSDCVideoAuthorizedFeature = hasAuthorizedFeatureSameDayVideo;
        const showMiniSpinner = showVideoVisitAvailability && !disableOnCallGetStarted && (typeof timeslots === 'undefined' || isWaiting && !isSuccess);
        const showErrorOnCallDoctor = showVideoVisitAvailability && !disableOnCallGetStarted && !isWaiting && isSuccess && (timeslots === 'undefined' || (timeslots && timeslots.length === 0) || this.availableTimesSDC.length === 0);
        const showLocalDoctor = !restrictLocalAndOncallDoctorTile && isActiveFeature_AmbulatoryVideoVisit;    
        const showMarkupOnCallDoctorError = (<div className="row on-call-error-container">
            <div className="col-12">
                <p>We're sorry, it looks like we're all booked.</p>
                <div className="other-options">Other options</div>
                <ul className="numbered-bullets">
                    <li><span>1</span>Skip the doctor's office with an <Link to={{ pathname: "/evisit", state: { hideProxySelector: true } }}>eVisit</Link></li>
                    {hasAAL && <li><span>2</span>Access your <a href="https://patient.doctorondemand.com/signin/?partner=american" target="_blank">DrOnDemand</a> service</li>}
                </ul>
            </div>
        </div>);

        const yourDoctorsList = (<ul className="angle-bullets">
            {!showVideoVisitAvailability && <li> Schedule within availability</li>}
            <li>{AmbulatoryCostLabel}</li>
            <li>Symptoms treated at the discretion of your doctor</li>
        </ul>);
        const newDoctorsList = (<ul className="angle-bullets">
            {!showVideoVisitAvailability && <li> Schedule within availability</li>}
            <li>{AmbulatoryCostLabel}</li>
            <li>Symptoms treated at the discretion of your doctor</li>
        </ul>);
        const onCallDoctorList = (<ul className="angle-bullets">
            {!showVideoVisitAvailability && <li> Schedule within availability</li>}
            {
                <li>
                    {SDCCostLabel}
                    {(disableOnCallGetStarted || (!isActiveFeature_SDCVideoVisit)) && !isProxyUser && <button className='btn text-btn' onClick={this.linkMyInsurance}>Link your insurance</button>}
                </li>
            }
            <li>Common symptoms treated<span className="icon-question" onClick={this.commonSymptomsInfo} /></li>
            {showSDC24By7TextInOnCallProvider ? <li> Appointments available 24/7 </li> : <li>Unable to refer you for COVID-19 testing</li> }
            
        </ul>);

        const noProvidersForNearMe = (<div><p>There are no BSWH providers within 20 miles of your location.</p><p>Find a New Doctor to expand your search.</p></div>);

        const timezone = Tools.getCentralDateWithFormat(new Date(), "z");

        return (
            <div className="container-fluid body-content video-visit-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="page-heading">Video Visit</h1>
                                {!showNotEligibleMsg && <div className="page-subheading">Select an option below to speak with a doctor using a camera enabled device</div>}
                            </div>
                        </div>
                        {restrictLocalAndOncallDoctorTile && !showYourDoctors ? restrictLocalAndOncallDoctorMarkup() : showNotEligibleMsg ? showMarkupForNotEligible :
                            <>
                                {outOfStateOptionsForSdc &&
                                    <div className="video-visit-start-container">
                                        <div className="row">
                                            <div className="col-12 maxWidth-content align-items-center evisit-travel__heading">
                                                <div className="svg-plane" /><p>Traveling outside Texas?
                                            <Link className="icontextlink mobile-wrapped-link" to={{ pathname: "/aatravel" }} >See More Options</Link></p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/*serverData && serverData.showTimeZoneMessage && !Tools.isCentralTimeZone() &&
                            <div className="details-icon-prepend video-visit-timezone-message">
                                <div className="icon-col">
                                    <span className="icon-clock" />
                                </div>
                                <div className="details-col">
                                    {`The times displayed below are in ${timeZones[timezone]} (${timezone}).`}
                                </div>
                            </div>
                        */}
                                <div className="row video-visit__mobile-tabs">
                                    <div className="col-12">
                                        <Nav tabs>
                                            {showYourDoctors && <NavItem className={this.state.activeTab === '1' ? 'tab-selected' : ''}>
                                                <NavLink className="option-tile" onClick={() => this.toggleTabs('1')}>
                                                    <div className="option-tile__icon">
                                                        <div className="svg-schedule-color" />
                                                    </div>
                                                    <div className="tab-heading">
                                                        My Doctor
                                            </div>
                                                </NavLink>
                                            </NavItem>}
                                            {showLocalDoctor &&
                                                <NavItem className={this.state.activeTab === '2' ? 'tab-selected' : ''}>
                                                    <NavLink className="option-tile" onClick={() => this.toggleTabs('2')}>
                                                        <div className="cant-wait-feature">CAN'T WAIT?</div>
                                                        <div className="option-tile__icon">
                                                            <div className="svg-find-care" />
                                                        </div>
                                                        <div className="tab-heading">
                                                            Local Doctor
                                                </div>
                                                    </NavLink>
                                                </NavItem>
                                            }
                                            {showOnCallDoctor &&
                                                <NavItem className={this.state.activeTab === '3' ? 'tab-selected' : ''} >
                                                    <NavLink className="option-tile" onClick={() => this.toggleTabs('3')}>
                                                        <div className="cant-wait-feature">CAN'T WAIT?</div>
                                                        <div className="option-tile__icon">
                                                            <div className="svg-conditions" />
                                                        </div>
                                                        <div className="tab-heading">
                                                            On-Call
                                                </div>
                                                    </NavLink>
                                                </NavItem>
                                            }
                                        </Nav>
                                    </div>
                                </div>
                                <div className="row row-card-eq video-visit__content">
                                    {showYourDoctors && <div className={"col-12 col-lg option-tile" + (this.state.activeTab === "1" ? " option-active" : "")}>
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="row">
                                                    <div className="col-12 option-tile__icon">
                                                        <div className="svg-schedule-color" />
                                                    </div>
                                                    <div className="col-12 card-heading">
                                                        My Doctor
                                            </div>
                                                    <div className="col-12">
                                                        {yourDoctorsList}
                                                    </div>
                                                </div>
                                            </div>
                                            {showVideoVisitAvailability &&
                                                <div className="card-body">
                                                    <div className="row">
                                                        <VideoVisitAvailability data={this.yourDoctorAvailableTimes}
                                                            error={earliestScheduleError}
                                                            type="YOURDOCTOR"
                                                            showMiniSpinner={earliestScheduleWaiting}
                                                            errorMsg={earliestScheduleSuccess && this.yourDoctorAvailableTimes.length === 0 ? "Your doctors don't have availability for a Video Visit in the next 30 days." : videoVisitTypeForYourDoctorAvailability ? "" : "View your doctors to see their available scheduling times."}
                                                            avatar={this.yourDoctorAvailableTimes.length > 0 ? this.yourDoctorAvailableTimes[0].photo : ""}
                                                            displayName={this.yourDoctorAvailableTimes.length > 0 ? this.yourDoctorAvailableTimes[0].displayName : ""}
                                                            specialty={this.yourDoctorAvailableTimes.length > 0 ? this.yourDoctorAvailableTimes[0].specialty : ""}
                                                            selectedUser={this.state.selectedUser}
                                                            isFromVideoVisitOptions
                                                            hasMoreButton
                                                            noSelectPatient
                                                            showTimeZoneMessage={showTimeZoneMessage}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            <div className="card-footer">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <button className="btn btn-primary" onClick={this.seeAllYourDoctors}>SEE ALL YOUR DOCTORS</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {showLocalDoctor &&
                                        <div className={"col-12 col-lg option-tile" + (this.state.activeTab === "2" ? " option-active" : "")}>
                                            <div className="card">
                                                <div className="cant-wait-feature">CAN'T WAIT?</div>
                                                <div className="card-header">
                                                    <div className="row">
                                                        <div className="col-12 option-tile__icon">
                                                            <div className="svg-find-care" />
                                                        </div>
                                                        <div className="col-12 card-heading">
                                                            Local Doctor
                                                </div>
                                                        <div className="col-12">
                                                            {newDoctorsList}
                                                        </div>
                                                    </div>
                                                </div>
                                                {showVideoVisitAvailability &&
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <VideoVisitAvailability data={this.state.newDoctorAvailableTimes}
                                                                error={newDoctorProvidersError}
                                                                type="FINDNEWDOCTOR"
                                                                showMiniSpinner={newDoctorProvidersWaiting || waitingOnGeoAddress || waitingOnGeolocation || fetchingUserAddress}
                                                                errorMsg={newDoctorProvidersSuccess && (!newDoctorProviders || (newDoctorProviders && newDoctorProviders.length === 0)) ? noProvidersForNearMe : ""}
                                                                avatar={this.state.newDoctorAvailableTimes.length > 0 ? this.state.newDoctorAvailableTimes[0].photo : ""}
                                                                displayName={this.state.newDoctorAvailableTimes.length > 0 ? this.state.newDoctorAvailableTimes[0].displayName : ""}
                                                                specialty={this.state.newDoctorAvailableTimes.length > 0 && this.state.newDoctorAvailableTimes[0].specialties && this.state.newDoctorAvailableTimes[0].specialties.length > 0 ? this.state.newDoctorAvailableTimes[0].specialties[0].Specialty : ""}
                                                                selectedUser={this.state.selectedUser}
                                                                isFromVideoVisitOptions
                                                                hasMoreButton
                                                                noSelectPatient
                                                                showTimeZoneMessage={showTimeZoneMessage}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <button className="btn btn-primary" onClick={this.findNewDoctor}>FIND A NEW DOCTOR</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {showOnCallDoctor && 
                                        <div className={"col-12 col-lg option-tile" + (this.state.activeTab === "3" ? " option-active" : "")}>
                                            <div className="card">
                                                <div className="cant-wait-feature">CAN'T WAIT?</div>
                                                <div className="card-header">
                                                    <div className="row">
                                                        <div className="col-12 option-tile__icon">
                                                            <div className="svg-conditions" />
                                                        </div>
                                                        <div className="col-12 card-heading">
                                                            On-Call Provider
                                                </div>
                                                        <div className="col-12">
                                                            {onCallDoctorList}
                                                        </div>
                                                    </div>
                                                </div>
                                                {showVideoVisitAvailability &&
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <VideoVisitAvailability data={this.availableTimesSDC}
                                                                error={isError}
                                                                type="ONCALLPROVIDER"
                                                                showMiniSpinner={showMiniSpinner}
                                                                displayName="BSWH Provider"
                                                                errorMsg={showErrorOnCallDoctor ? showMarkupOnCallDoctorError : disableOnCallGetStarted ? "Please link your insurance to see available times to schedule." : ""}
                                                                isFromVideoVisitOptions
                                                                showTimeZoneMessage={showTimeZoneMessage}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                <div className="card-footer">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            {!(showErrorOnCallDoctor && showMarkupOnCallDoctorError) && <button disabled={disableOnCallGetStarted} className="btn btn-primary" onClick={this.SeeAllSlotsInOnCallDoctor}>{this.availableTimesSDC.length > 0 ? "SEE MORE TIMES" : "SEE AVAILABLE TIMES"}</button>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <Modal className="modal-symptoms" isOpen={this.state.openModal} toggle={this.toggleModal}>
                                    <ModalHeader toggle={this.toggleModal} />
                                    <ModalBody>
                                        <CommonSymptoms symptoms={symptoms} isSymptomsWaiting={isSymptomsWaiting} />
                                    </ModalBody>
                                </Modal>
                            </>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    const enableVirtualDashboardUpdates = state.session.serverData && state.session.serverData.enableVirtualDashboardUpdates;

    let userCity = "";
    let userState = "";
    if (!state.healthSource.fetchingUserAddress && state.healthSource.userAddress && state.healthSource.userAddress.length > 0) {
        userCity = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].City : userCity;
        userState = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].State : userState;
    }

    return {
        hasAAL: state.memberships.hasAA,
        isProxyUser: state.domain.ip,
        hasSwhp: state.memberships.hasAnySWHP,
        symptoms: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions : null,
        isSymptomsWaiting: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions.isWaiting : false,
        videoVisitTimeSlots: state.videoVisitScheduling.videoVisitTimeSlots ? state.videoVisitScheduling.videoVisitTimeSlots : {},
        providerList: state.directScheduling.providerList,
        providerNpiListStr: state.directScheduling.providerNpiListStr,
        providerNpiList: state.directScheduling.providerNpiList,
        providerListPending: state.directScheduling.providerListPending,
        serverData: state.session.serverData,
        showVideoVisitAvailability: state.session.serverData ? state.session.serverData.showVideoVisitAvailability : false,
        showTimeZoneMessage: state.session.serverData ? state.session.serverData.showTimeZoneMessage : false,
        newDoctorProviders: state.providers.providers,
        newDoctorProvidersWaiting: state.providers.searchRunning,
        newDoctorProvidersSuccess: state.providers.success,
        newDoctorProvidersError: state.providers.error,
        isCurrentLocation: state.locations.isCurrentLocation,
        curPosLatitude: state.locations.latitude,
        curPosLongitude: state.locations.longitude,
        geolocationError: state.locations.geolocationError,
        city: userCity,
        state: userState,
        userName: state.sso.userDetails.userName,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress,
        geoAddressError: state.locations.geoAddressError,
        fetchingUserAddress: state.healthSource.fetchingUserAddress,
        waitingOnGeolocation: state.locations.waitingOnGeolocation,
        earliestScheduleSuccess: state.providers.earliestScheduleSuccess,
        earliestScheduleWaiting: state.providers.earliestScheduleWaiting,
        earliestScheduleError: state.providers.earliestScheduleError,
        earliestScheduleProvider: state.providers.earliestScheduleProvider,
        videoVisitTypeForYourDoctorAvailability: state.session.serverData && state.session.serverData.videoVisitTypeForYourDoctorAvailability,
        activeProfile: state.memberships.activeProfile,
        SDCCostLabel: state.memberships.SDCCostLabel,
        AmbulatoryCostLabel: state.memberships.AmbulatoryCostLabel,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        isActiveFeature_AmbulatoryVideoVisit: state.memberships.isActiveFeature_AmbulatoryVideoVisit,
        outOfStateOptionsForSdc: state.memberships.outOfStateOptionsForSdc,
        hasAuthorizedFeatureSameDayVideo: state.memberships.hasAuthorizedFeatureSameDayVideo,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : "",
        token: state.domain.t,
        currentuser: d.hydrateProxyUser(state.domain.cu),
        isSwitchingProxy: state.memberships.switchingProxyUser,
        showSDC24By7TextInOnCallProvider: state.session.serverData && state.session.serverData.showSDC24By7TextInOnCallProvider
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitConditions: () => dispatch({ type: types.GET_VIDEO_VISIT_CONDITIONS }),
        getVideoVisitTimeSlots: (clientUTCOffset, date) => dispatch({ type: types.GET_VIDEO_VISIT_TIME_SLOTS, data: { clientUTCOffset, date } }),

        searchProviders: (searchModel, callback) => {
            dispatch({ type: types.SEARCH_PROVIDER, searchModel: searchModel, callback: callback });
        },
        getUserAddress: (userName) => {
            dispatch({
                type: types.GET_USER_ADDRESS_START, userName: userName
            });
        },
        getGeoLocation: (useCurrentLocation) => dispatch({ type: types.GEOLOCATION, useCurrentLocation: useCurrentLocation }),
        getProvidersListByVisitType: (searchModel, token) => {
            dispatch({ type: types.GET_PROVIDERS_LIST_BY_VISITTYPE, searchModel: searchModel, token });
        },
        getProviderWithEarliestSchedule: (searchModel) => {
            dispatch({ type: types.GET_PROVIDER_WITH_EARLIESTSCHEDULE, searchModel: searchModel });
        },
        resetNewDoctorResults: () => {
            dispatch({
                type: types.SEARCH_PROVIDER_CLEAR
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoVisitOptions);